import { atomWithReset } from "jotai/utils";

export const confirmAutomationSubmitModalAtom = atomWithReset<{
  visible: boolean;
}>({
  visible: false
});
